export enum DeliveryOptions {
  DeliverToPostcode = 'deliver-to-postcode',
  Collection = 'collection',
  LocalCollection = 'local-collection',
  Blank = ''
}

export type DeliveryOption = 'deliver-to-postcode' | 'collection' | 'local-collection' | '';
